export default __webpack_public_path__ + "static/media/edit.607f1f86.png";